import { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgDummy1 from "../../Assets/background/bgDummy1.jpg"; // adjust path
import bgDummy2 from "../../Assets/background/bgDummy2.jpg"; // adjust path

export default function SelectBG() {
  const [selectedBg, setSelectedBg] = useState("1");
  const navigate = useNavigate();

  const handleNext = () => {
    if (selectedBg) {
      navigate(`/${selectedBg}`);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        height: "96dvh",
        alignItems: "center",
      }}
    >
      <div
        style={{
          top: "20px",
          color: "#fff",
          textAlign: "center",
          fontSize: "28px",
          fontWeight: "bold",
          width: "100%",
        }}
      >
        Select Background
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        {/* BG 1 */}
        <div
          onClick={() => setSelectedBg("1")}
          style={{ width: "40%", textAlign: "center" }}
        >
          <img
            src={bgDummy1}
            alt="Background 1"
            width={"100%"}
            style={{
              border: selectedBg === "1" ? "2px solid blue" : "none",
            }}
          />

          <input
            type="radio"
            name="bg"
            value="1"
            checked={selectedBg === "1"}
            onChange={(e) => setSelectedBg(e.target.value)}
            style={{
              transform: "scale(2)",
              margin: "10px",
            }}
          />
        </div>

        {/* BG 2 */}
        <div
          onClick={() => setSelectedBg("2")}
          style={{ width: "40%", textAlign: "center" }}
        >
          <img
            src={bgDummy2}
            alt="Background 2"
            width={"100%"}
            style={{ border: selectedBg === "2" ? "2px solid blue" : "none" }}
          />

          <input
            type="radio"
            name={"bg"}
            value="2"
            checked={selectedBg === "2"}
            onChange={(e) => setSelectedBg(e.target.value)}
            style={{
              transform: "scale(2)",
              margin: "10px",
            }}
          />
        </div>
      </div>

      {/* Next button appears only after selecting */}
      <button
        className="rippleBtn"
        disabled={!selectedBg}
        onClick={handleNext}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        Next
      </button>
    </div>
  );
}
